
import { supabase } from '@/integrations/supabase/client';
import { logWithTimestamp, AuthEvent, logAuthEvent } from '../utils/authUtils';
import { getValidUserTypes, normalizeUserType } from '../utils/userTypeUtils';

/**
 * Initiates Google OAuth sign-in process using Supabase's built-in OAuth handler
 * @param userType Optional user type to set for new users
 * @returns Promise with the OAuth response data
 */
export async function signInWithGoogle(userType?: string) {
  logAuthEvent(AuthEvent.SIGNED_IN, null, { provider: 'google', action: 'initiate' });
  logWithTimestamp('Starting Google sign in process');
  
  try {
    // Validate/normalize the user type if provided
    let validatedUserType = 'standard'; // Default to standard (which is safe)
    
    if (userType) {
      // Use normalizeUserType utility to ensure a valid user type
      validatedUserType = await normalizeUserType(userType, 'standard');
      logWithTimestamp(`Normalized user_type for Google sign-in: ${userType} -> ${validatedUserType}`);
    } else {
      logWithTimestamp('No user_type provided, using default: standard');
    }
    
    // Use the correct structure for Supabase v2 Auth API
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: `${window.location.origin}?user_type=${validatedUserType}`,
        queryParams: {
          access_type: 'offline',
          prompt: 'consent',
        }
      }
    });
    
    if (error) {
      logWithTimestamp('Google sign in error:', error);
      throw error;
    }
    
    logWithTimestamp('Google sign in initiated successfully');
    return data;
  } catch (error) {
    logWithTimestamp('Exception during Google sign in:', error);
    throw error;
  }
}
